/**
 * Created by m.igrachev on 6/30/2017.
 */
import React from "react";
import PropTypes from "prop-types";
import documentedProps from "./documentation/ControlMessageGroupDocumentedProps";

import("./ControlMessages.less");

const GroupIconMap = {
    error: "tq-o-icon-cancel",
    success: "tq-o-icon-check",
    warning: "tq-o-icon-alert",
    info: "tq-o-icon-circle-info",
    neutral: "tq-o-icon-circle-question-mark"
};

const VisualizationClass = {
    dark: "tq-alert-dark",
    accent: "tq-alert-accent",
    light: "" //This is the default!
};

export default class ControlMessageGroup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            collapsed: !!props.expandable
        };

        this.onToggleExpand = this.onToggleExpand.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    onClose() {
        if (this.props.onClose) {
            this.props.onClose(this.state, this.props);
        }
    }

    onToggleExpand() {
        this.setState(
            {
                collapsed: !this.state.collapsed
            },
            () => {
                //Inform consumer
                if (this.props.onToggleExpand) {
                    this.props.onToggleExpand(this.state);
                }
            }
        );
    }

    buildMessages() {
        let result = [];

        React.Children.forEach(this.props.children, (child, index) => {
            if (React.isValidElement(child)) {
                result.push(<li key={index}>{child}</li>);
            }
        });

        return result;
    }

    render() {
        let type = this.props.groupType || "error";
        let visualizationClass = VisualizationClass[this.props.theme || "light"];
        let className = `tq-alert tq-alert-${type} tq-new-alert ${visualizationClass}`;
        className += this.props.expandable && this.state.collapsed ? "" : " tq-expanded";
        className += this.props.bigIcon ? " tq-alert-large-icon" : "";
        className += this.props.extraClasses ? ` ${this.props.extraClasses}` : "";
        let expandArrowDirection = this.props.reverseExpandDirection ? "up" : "down";
        let icon;
        let hasAlertIcon = !this.props.skipAlertIcon;
        if (hasAlertIcon) {
            icon = this.props.icon || GroupIconMap[type];
        }

        let messages = this.buildMessages();

        return (
            <div className={className} data-tq-id={this.props.dataTqId}>
                {icon && (
                    <div className="tq-alert-icon">
                        <i className={icon} />
                    </div>
                )}
                <div className="tq-alert-content">
                    <div className="tq-fixed-container">
                        <div className="tq-fixed-top">
                            {!this.props.skipName && (
                                <h3 className="tq-title">
                                    <span className="tq-text-node">{this.props.name}</span>
                                </h3>
                            )}
                            {this.props.expandable &&
                                this.state.collapsed &&
                                this.props.collapsedHint && (
                                    <ul>
                                        <li>
                                            <p>{this.props.collapsedHint}</p>
                                        </li>
                                    </ul>
                                )}
                        </div>
                        {!this.state.collapsed && (
                            <div className="tq-fixed-content tq-hidden-content">
                                <div className="tq-main-content">
                                    <ul>{messages}</ul>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {this.props.closable && (
                    <i
                        className="tq-alert-close tq-icon-close tq-clickable"
                        onClick={this.onClose}
                    />
                )}
                {this.props.expandable && (
                    <i
                        className={
                            "tq-alert-top-btn tq-icon-arrow-" +
                            expandArrowDirection +
                            "-big tq-clickable"
                        }
                        onClick={this.onToggleExpand}
                    />
                )}
            </div>
        );
    }
}

ControlMessageGroup.displayName = "ControlMessageGroup";

ControlMessageGroup.propTypes = {
    theme: PropTypes.oneOf(["light", "dark", "accent"]), //Coming from parent!
    groupType: PropTypes.oneOf(["error", "success", "warning", "info", "neutral"]),
    expandable: PropTypes.bool,
    closable: PropTypes.bool,
    reverseExpandDirection: PropTypes.bool,
    bigIcon: PropTypes.bool, //Coming from parent!
    icon: PropTypes.string,
    skipAlertIcon: PropTypes.bool,
    name: PropTypes.string,
    skipName: PropTypes.bool, //In case name is defaulted and we need to skip it!
    collapsedHint: PropTypes.string,
    onToggleExpand: PropTypes.func,
    onClose: PropTypes.func,
    dataTqId: PropTypes.string,
    extraClasses: PropTypes.string
};

ControlMessageGroup.documentedProps = documentedProps;
